import * as i0 from '@angular/core';
import { Component, Input, Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i1$1 from '@angular/cdk/overlay';

class LoaderComponent {
    constructor() {
        this.message = '';
    }
    ngOnInit() { }
}
LoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.0", type: LoaderComponent, selector: "ff-loader", inputs: { mode: "mode", value: "value", message: "message" }, ngImport: i0, template: "<mat-progress-spinner [mode]=\"mode\" [value]=\"value\"></mat-progress-spinner>\r\n<p>{{message}}</p>\r\n", styles: [":host{position:fixed;width:100%;z-index:9999;top:0;left:0;min-height:100%;height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;background-color:hsla(0,0%,100%,.5)}:host p{color:var(--total-gray-800);font-weight:700}"], components: [{ type: i1.MatProgressSpinner, selector: "mat-progress-spinner", inputs: ["color", "mode", "diameter", "strokeWidth", "value"], exportAs: ["matProgressSpinner"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ff-loader',
                    templateUrl: './loader.component.html',
                    styleUrls: ['./loader.component.scss']
                }]
        }], propDecorators: { mode: [{
                type: Input
            }], value: [{
                type: Input
            }], message: [{
                type: Input
            }] } });

// @dynamic
class LoaderService {
    constructor(_componentFactoryResolver, _overlay) {
        this._componentFactoryResolver = _componentFactoryResolver;
        this._overlay = _overlay;
        this._overlayRef = _overlay.create();
        this._portal = new ComponentPortal(LoaderComponent);
    }
    add(value) {
        this.show();
        this._componentRef.instance.mode = 'determinate';
        this._componentRef.instance.value += value;
        if (this._componentRef.instance.value >= 100) {
            this._componentRef.instance.value = 0;
            this.hide();
        }
    }
    _reset() {
        if (this._componentRef) {
            this._componentRef.instance.mode = 'indeterminate';
            this._componentRef.instance.value = 0;
        }
    }
    show(message) {
        if (!this._portal.isAttached) {
            this._componentRef = this._overlayRef.attach(this._portal);
            this._componentRef.instance.message = message;
            this._reset();
        }
    }
    hide() {
        if (this._componentRef) {
            this._overlayRef.detach();
            this._componentRef = null;
        }
    }
    isVisible() {
        return this._componentRef;
    }
}
LoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoaderService, deps: [{ token: i0.ComponentFactoryResolver }, { token: i1$1.Overlay }], target: i0.ɵɵFactoryTarget.Injectable });
LoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoaderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoaderService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i1$1.Overlay }]; } });

class LoaderModule {
}
LoaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LoaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoaderModule, declarations: [LoaderComponent], imports: [CommonModule, MatProgressSpinnerModule] });
LoaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoaderModule, providers: [LoaderService], imports: [[CommonModule, MatProgressSpinnerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: LoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, MatProgressSpinnerModule],
                    declarations: [LoaderComponent],
                    providers: [LoaderService],
                    exports: []
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LoaderComponent, LoaderModule, LoaderService };
